import React from "react"

export const SourcesSyndrome = () => {

return(
<div>
https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7147654/<br />
https://medlineplus.gov/metabolicsyndrome.html<br />
</div>
)
}